import { Card, CardBody, Col } from "reactstrap";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Image } from "../../../../AbstractElements";
import { disableTouchSubTitle, disableTouchSwipingData } from "../../../../Data/BonusUi/Slider";
import { dynamicImage } from "../../../../Utils";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import { DisableTouchSwipingTitle } from "../../../../Utils/Constants";

export default function DisableTouchSwiping() {
  return (
    <Col xl={6} xs={12}>
      <Card>
        <CommonCardHeader headClass="pb-0" title={DisableTouchSwipingTitle} subTitle={disableTouchSubTitle} />
        <CardBody>
          <Swiper modules={[Navigation]} navigation loop slidesPerView={1} simulateTouch={false}>
            {disableTouchSwipingData?.map((item, index) => (
              <SwiperSlide key={index}>
                <Image src={dynamicImage(`slider/${item.image}`)} alt="drawing-room" className="d-block w-100" />
              </SwiperSlide>
            ))}
          </Swiper>
        </CardBody>
      </Card>
    </Col>
  );
}
